module.exports = __webpack_public_path__ + "static/media/Q3_figure.3177c50a.png";